// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n#cart-badge[data-v-42845988] {\n    position: absolute;\n    top: 0px;\n    right: -6px;\n    font-size: 9px;\n    padding: 2.5px;\n    width: 14px;\n    height: 14px;\n    letter-spacing: -1.1px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
